export const HERO_IMG =
  "https://images.pexels.com/photos/16573669/pexels-photo-16573669.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export const CATEGORY_IMAGES = {
  "فيلا": "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&q=80&w=1200",
  "شقة": "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&q=80&w=1200",
  "أرض": "https://images.unsplash.com/photo-1506501139174-099022df5260?auto=format&fit=crop&q=80&w=1200",
  "مكتب": "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&q=80&w=1200",
};

export const CITY_IMAGES = {
  "جدة": "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&q=80&w=1200",
  "الرياض": "https://images.unsplash.com/photo-1506795213373-430e921fe2ed?auto=format&fit=crop&q=80&w=1200",
  "الدمام": "https://images.unsplash.com/photo-1570724546132-6a61bb3c3894?auto=format&fit=crop&q=80&w=1200",
};

export const FALLBACK_IMG = HERO_IMG;
